import { orderPromoDetails } from '../../../utils/orderPromoDetails';
import OrderTotals from '../../promo/OrderTotals';
import React from 'react';
import { BASE_URL } from '../../../shared/constants';
import { renderPrice } from '../../../utils/adminOrderService';
import PreOrderBlock from '../../PreOrderBlock';
import ProductDiscountImage from '../../ProductDiscountImage';

const OrderItemsDesktop = ({
                             order,
                             items,
                             totalPrice,
                             discountedPrice,
                             setModalImage
                           }) => {
  if (!items?.length) return null;

  const finalTotal = order?.finalTotal ?? discountedPrice;
  const promo = orderPromoDetails(order);

  return (
    <div className="card mb-3">
      <h5 className="card-header font-weight-bold">
        🛒 Товари в замовленні
      </h5>

      <div className="card-body">
        {items.map((item, index) => (
          <div
            key={index}
            className={`row py-2 align-items-center ${
              index !== items.length - 1 ? 'border-bottom' : ''
            }`}
          >
            <div className="col-2">
              <ProductDiscountImage price={item.price} discountedPrice={item.discountedPrice}
                personalDiscount={item.personalDiscount} productDiscount={item.productDiscount}>
                <img
                  src={`${BASE_URL}/api/v1/product/image/${item.image}`}
                  alt={item.name}
                  className="img-fluid cursor-pointer"
                  data-toggle="modal"
                  data-target="#imageModalDesktop"
                  onClick={() => setModalImage(item.image)}
                />
              </ProductDiscountImage>
            </div>

            <div className="col-6">
              <div className="font-weight-bold">{item.name}</div>
              <div style={{ fontSize: 14 }}>
                {item.productCode && (
                  <div className="text-muted">Артикул: <b>{item.productCode}</b></div>
                )}
                {(item.state?.databaseValue === 'PREORDER' || item.toOrder) && (
                  <PreOrderBlock expectedArrivalDate={item.expectedArrivalDate} />
                )}
              </div>
            </div>

            <div className="col-4 d-flex justify-content-center align-items-center">
              {item.quantity} шт
              <span className='mx-1'>х</span>
              {renderPrice(item)}
            </div>
          </div>
        ))}
      </div>

      <OrderTotals totalPrice={totalPrice} finalTotal={finalTotal} promo={promo} showPromoCode savingsLabel='Загальна економія' />
    </div>
  );
};

export default OrderItemsDesktop;
